import {getErrorClassName} from '../components/front/applicants/ApplicantForm.tsx'

const errorClassName = getErrorClassName();

window.addEventListener("load", () => {
  // イベント詳細画面の申込フォームでバリデーションエラーが発生した場合申込フォームまで移動
  const applicantForm = document.getElementById("applicant_form");
  const errorMessage = document.getElementsByClassName(errorClassName);
  const flashMessage = document.querySelector('.alert__message');
  if (applicantForm && (errorMessage.length > 0 || flashMessage)) {
    applicantForm.scrollIntoView();
  }
});
